import { render, staticRenderFns } from "./UploadLedger.vue?vue&type=template&id=5e2f698b"
import script from "./UploadLedger.vue?vue&type=script&lang=js"
export * from "./UploadLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports